import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0f3ba86c from 'nuxt_plugin_plugin_0f3ba86c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_a8199974 from 'nuxt_plugin_sentryserver_a8199974' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_4639c1be from 'nuxt_plugin_sentryclient_4639c1be' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_39565302 from 'nuxt_plugin_plugin_39565302' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_54e32054 from 'nuxt_plugin_plugin_54e32054' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_plugin_af870eb8 from 'nuxt_plugin_plugin_af870eb8' // Source: ./sanity/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_d1efda1e from 'nuxt_plugin_recaptcha_d1efda1e' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_pluginutils_b2fc660e from 'nuxt_plugin_pluginutils_b2fc660e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7979fff8 from 'nuxt_plugin_pluginrouting_7979fff8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7fd189eb from 'nuxt_plugin_pluginmain_7fd189eb' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_bc5b5650 from 'nuxt_plugin_gtm_bc5b5650' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_apollomodule_54778164 from 'nuxt_plugin_apollomodule_54778164' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_50b3d4fc from 'nuxt_plugin_axios_50b3d4fc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_datadogRum_4c047e68 from 'nuxt_plugin_datadogRum_4c047e68' // Source: ../../../src/plugins/datadogRum (mode: 'client')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../../../src/plugins/filters (mode: 'all')
import nuxt_plugin_qrCodeReader_82b82bf6 from 'nuxt_plugin_qrCodeReader_82b82bf6' // Source: ../../../src/plugins/qrCodeReader (mode: 'client')
import nuxt_plugin_userAttribution_b83e9980 from 'nuxt_plugin_userAttribution_b83e9980' // Source: ../../../src/plugins/userAttribution (mode: 'client')
import nuxt_plugin_uniqueId_463566c0 from 'nuxt_plugin_uniqueId_463566c0' // Source: ../../../src/plugins/uniqueId (mode: 'client')
import nuxt_plugin_sanityImage_426902b9 from 'nuxt_plugin_sanityImage_426902b9' // Source: ../../../src/plugins/sanityImage (mode: 'client')
import nuxt_plugin_sanityLookup_0ff87bdc from 'nuxt_plugin_sanityLookup_0ff87bdc' // Source: ../../../src/plugins/sanityLookup (mode: 'client')
import nuxt_plugin_walletHelper_4631ce0a from 'nuxt_plugin_walletHelper_4631ce0a' // Source: ../../../src/plugins/walletHelper (mode: 'client')
import nuxt_plugin_pubnub_3c602a52 from 'nuxt_plugin_pubnub_3c602a52' // Source: ../../../src/plugins/pubnub (mode: 'client')
import nuxt_plugin_restrictionsService_bbfce7cc from 'nuxt_plugin_restrictionsService_bbfce7cc' // Source: ../../../src/plugins/restrictionsService (mode: 'client')
import nuxt_plugin_filmApiService_3d6a2ad3 from 'nuxt_plugin_filmApiService_3d6a2ad3' // Source: ../../../src/plugins/filmApiService (mode: 'client')
import nuxt_plugin_musicDataService_24c48a3a from 'nuxt_plugin_musicDataService_24c48a3a' // Source: ../../../src/plugins/musicDataService (mode: 'client')
import nuxt_plugin_recaptchaService_bd91f47c from 'nuxt_plugin_recaptchaService_bd91f47c' // Source: ../../../src/plugins/recaptchaService (mode: 'client')
import nuxt_plugin_auth_92710cc8 from 'nuxt_plugin_auth_92710cc8' // Source: ../../../src/plugins/auth (mode: 'client')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../../../src/plugins/chart.js (mode: 'client')
import nuxt_plugin_meta_63ff0066 from 'nuxt_plugin_meta_63ff0066' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page-fade","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Gala Film","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"theme-color","content":"#ffffff"},{"name":"facebook-domain-verification","content":"d9en3pdd5mjfz0jvzs125nldic9lp3"},{"name":"naver-site-verification","content":"75445707aaa9dc2d575d28c45faab4eaade6c125"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:300,400,500,700&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Barlow+Condensed:wght@700&display=swap"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"hid":"googleOptimize","src":"https:\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=OPT-MMBVRNV"},{"id":"usercentrics-cmp","src":"https:\u002F\u002Fapp.usercentrics.eu\u002Fbrowser-ui\u002Flatest\u002Floader.js","data-settings-id":"cxn0_lf-E","async":true},{"id":"google-chromecast","src":"https:\u002F\u002Fwww.gstatic.com\u002Fcv\u002Fjs\u002Fsender\u002Fv1\u002Fcast_sender.js?loadCastFramework=1","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T657TRZ')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T657TRZ&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0f3ba86c === 'function') {
    await nuxt_plugin_plugin_0f3ba86c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_a8199974 === 'function') {
    await nuxt_plugin_sentryserver_a8199974(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_4639c1be === 'function') {
    await nuxt_plugin_sentryclient_4639c1be(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_39565302 === 'function') {
    await nuxt_plugin_plugin_39565302(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_54e32054 === 'function') {
    await nuxt_plugin_plugin_54e32054(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_af870eb8 === 'function') {
    await nuxt_plugin_plugin_af870eb8(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_d1efda1e === 'function') {
    await nuxt_plugin_recaptcha_d1efda1e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_b2fc660e === 'function') {
    await nuxt_plugin_pluginutils_b2fc660e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7979fff8 === 'function') {
    await nuxt_plugin_pluginrouting_7979fff8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7fd189eb === 'function') {
    await nuxt_plugin_pluginmain_7fd189eb(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_bc5b5650 === 'function') {
    await nuxt_plugin_gtm_bc5b5650(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_54778164 === 'function') {
    await nuxt_plugin_apollomodule_54778164(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_50b3d4fc === 'function') {
    await nuxt_plugin_axios_50b3d4fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogRum_4c047e68 === 'function') {
    await nuxt_plugin_datadogRum_4c047e68(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_qrCodeReader_82b82bf6 === 'function') {
    await nuxt_plugin_qrCodeReader_82b82bf6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_userAttribution_b83e9980 === 'function') {
    await nuxt_plugin_userAttribution_b83e9980(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uniqueId_463566c0 === 'function') {
    await nuxt_plugin_uniqueId_463566c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sanityImage_426902b9 === 'function') {
    await nuxt_plugin_sanityImage_426902b9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sanityLookup_0ff87bdc === 'function') {
    await nuxt_plugin_sanityLookup_0ff87bdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_walletHelper_4631ce0a === 'function') {
    await nuxt_plugin_walletHelper_4631ce0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pubnub_3c602a52 === 'function') {
    await nuxt_plugin_pubnub_3c602a52(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_restrictionsService_bbfce7cc === 'function') {
    await nuxt_plugin_restrictionsService_bbfce7cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filmApiService_3d6a2ad3 === 'function') {
    await nuxt_plugin_filmApiService_3d6a2ad3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_musicDataService_24c48a3a === 'function') {
    await nuxt_plugin_musicDataService_24c48a3a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recaptchaService_bd91f47c === 'function') {
    await nuxt_plugin_recaptchaService_bd91f47c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_92710cc8 === 'function') {
    await nuxt_plugin_auth_92710cc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_63ff0066 === 'function') {
    await nuxt_plugin_meta_63ff0066(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
